<template>
    <div class="row">
        <draggable v-model="items" tag="div" @end="checkMove" class="col-12">
            <div v-if="items.length > 0" v-for="(item, itemIndex) in items" :key="itemIndex" class="row">
                <div class="col-md-6">
                    <label>Section</label>
                    <select-component
                        @selectedValue="selectedValue($event, itemIndex)"
                        :name="'invalidates['+itemIndex+'][specification_item_type_id]'"
                        url-search="/specification_item_types/list-of-choices"
                        :url-show="'/specification_item_types/show-choice/'+item.specification_item_type_id"
                        :initial-value="item.specification_item_type_id">
                    </select-component>
                </div>
                <div class="col-md-5">
                    <label>Options</label>
                    <select v-if="item.options" v-model="item.option_id" :name="'invalidates['+itemIndex+'][option_id]'" class="form-control">
                        <option v-for="(op, indexOp) in item.options" :key="item.specification_item_type_id + '-' + indexOp"  :value="op.id">{{ op.name }}</option>
                    </select>
                </div>
                <div class="col-md-1">
                    <label style="display: block">&nbsp;</label>
                    <a style="margin-top: -1px;" @click="deleteLine(item.id, itemIndex)" title="Delete"
                       class="btn btn-danger text-white"><span
                        class="fa fa-trash"></span></a>
                </div>
                <div class="col-md-12 text-center" v-if="itemIndex < (items.length - 1)">
                    <div class="row">
                        <div class="col-md-5"></div>
                        <div class="col-md-2">
                            <select v-model="item.operator" :name="'invalidates['+itemIndex+'][operator]'"
                                    class="form-control" style="border: 1px solid red">
                                <option>AND</option>
                                <option>OR</option>
                            </select>
                        </div>
                        <div class="col-md-5"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <button @click="addLine()" type="button"
                            class="btn btn-info"
                            data-toggle="tooltip"
                            data-original-title="Add more lines">
                        <i class="glyphicon glyphicon-plus-sign"></i>
                        Add Invalidate Criteria
                    </button>
                </div>
            </div>
        </draggable>

    </div>
</template>

<script>
import draggable from 'vuedraggable'
import _ from "lodash";

export default {
    props: {
        invalidates: {
            type: Array,
            default: []
        }
    },
    components: {
        draggable,
    },
    data: function () {
        return {
            items: [],
            order: 0,
        }
    },
    mounted() {
        if (this.invalidates.length > 0) {
            for (let i = 0; i < this.invalidates.length; i++) {
                let item = JSON.parse(JSON.stringify(this.invalidates[i]));
                item["options"] = [];
                this.items.push(item)
                this.selectedValue(this.items[i]['specification_item_type_id'],i);
            }
        }
    },
    methods: {
        addLine() {
            let item = {
                specification_item_type_id: null,
                option_id: null,
                operator: 'AND',
                options: []
            }
            item.order = ++this.order
            item['index'] = item.order
            this.items.push(item);
        },
        deleteLine(id, itemIndex) {
            if (id) {
                this.$loading(true);
                let app = this;
                axios.delete(URL_BASE + '/work_orders/material/' + id)
                    .then((response) => {
                        this.$loading(false);
                        app.items.splice(itemIndex, 1);
                    })
                    .catch(error => {
                        this.$loading(false);
                        let message = '';
                        if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'Request failed with status code ' + error.response.status;

                        } else {
                            message = 'Application failed with error: ' + error.message;
                            console.log(error);
                        }

                        showMessage('w', message);


                    })
            } else {
                this.items.splice(itemIndex, 1);
            }

        },
        checkMove: function () {

            for (let i = 0; i < this.items.length; i++) {
                this.items[i].index = i + 1;
            }
        },
        selectedValue(value, index) {
            var app = this
            if (!value) {
                app.items[index]['options'] = []
                return;
            }
            axios.get(`/specification_item_types/${value}/options`)
                .then((response) => {
                    app.items[index]['options'] = response.data
                })
                .catch(error => {
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {

                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);

                })
                .then(() => {
                    this.$loading(false);
                });
        },
    }
}
</script>

<style scoped>

</style>
